import http from '../http-common'

const getAll = () => {
  return http.get('/project-types')
}

export const projectTypesService = {
    getAll,
}
